import React from 'react';
import { Flex, Box } from 'grid-styled';
import styled from 'styled-components';
import Container from 'components/Container';

import img from './skywallet_1.jpg';
import img2 from './skywallet_2.jpg';
/* eslint-enable global-require */

const Wrapper = styled(Box)`
    padding: 0 0 80px 0;
`;

const Img1 = styled.img`
    width: 97%;
    height: auto;
    padding-right: 1.2vw;

    @media (max-width: 831px) {
      width: 100%;
      padding: 20px 0 20px 0;
    }
`;

const Img2 = styled.img`
    width: 97%;
    height: auto;
    padding-left: 1.2vw;

    @media (max-width: 831px) {
      width: 100%;
      padding: 20px 0 20px 0;
    }
`;

const StyledBox = styled(Flex)`
`;

const skywalletGallery = () => (
  <Wrapper>
    <Container>
      <StyledBox width={[1, 1, 100 / 100]} justify="space-between" row wrap>
        <Box width={[1, 1, 50 / 100]}>
          <Img1 src={img} alt="test" />
        </Box>
        <Box width={[1, 1, 50 / 100]}>
          <Img2 src={img2} alt="test" />
        </Box>
      </StyledBox>
    </Container>
  </Wrapper>
);

export default skywalletGallery;



// WEBPACK FOOTER //
// ./src/components/Skywallet/components/Gallery/Gallery.js